import request from '@/utils/request'


//查询vip课程卡
export function fechListLessonVipCard(data) {
  return request({
    url: '/admin/lesson/card/qlLessonVipCard',
    method: 'post',
    data: data
  })
}

//查询体验课课程卡
export function fechListLessonExpCard(data) {
  return request({
    url: '/admin/lesson/card/qlLessonExpCard',
    method: 'post',
    data: data
  })
}
//新增体验卡
export function createExpCard(data) {
  return request({
    url: '/admin/lesson/card/createExpCard',
    method: 'post',
    data: data
  })
}
//主业务
export function updateLessonsName(data) {
  return request({
    url: '/admin/lessons/updateLessonsName',
    method: 'put',
    data: data
  })
}
//多业务
export function updateMoreLessons(data) {
  return request({
    url: '/admin/lessons/updateMoreLessons',
    method: 'post',
    data: data
  })
}
//创建课程VIP卡
export function newLessonVipCard(data) {
  return request({
    url: '/admin/lesson/card/newLessonVipCard',
    method: 'post',
    data: data
  })
}


//创建课程体验卡卡
export function newLessonExpCard(data) {
  return request({
    url: '/admin/lesson/card/newLessonExpCard',
    method: 'post',
    data: data
  })
}
//禁用课程卡
export function forbitLessonCard(params) {
  return request({
    url: '/admin/lesson/card/forbitLessonCard',
    method: 'get',
    params: params
  })
}
export function useLessonCard(params) {
  return request({
    url: '/admin/lesson/card/useLessonCard',
    method: 'get',
    params: params
  })
}

//创建卡的子类型
export function newCardSubType(data) {
  return request({
    url: '/admin/lesson/card/newCardSubType',
    method: 'post',
    data: data
  })
}

//查询卡子类型列表
export function getCardSubTypeList(data) {
  return request({
    url: '/admin/lesson/card/getCardSubTypeList',
    method: 'post',
    data: data
  })
}

//添加业务
export function addStorelesson(data) {
  return request({
    url: '/admin/storelesson/saveStoreLesson',
    method: 'post',
    data: data
  })
}
// 跟进业务选择获取
export function getValByBusinessId(data) {
  return request({
    url: `/admin/lessons/findStoreLessonsConversionList/${data.id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/StoreLessonCard.js